import Cookies from 'js-cookie'

const TokenKey = 'Hfcloud-Token'

export function getToken() {
  return Cookies.get(TokenKey)
}

export function setToken(token) {
  return Cookies.set(TokenKey, token)
}

export function removeToken() {
  return Cookies.remove(TokenKey)
}
export function getUser() {
  return JSON.parse(Cookies.get('User'))
}
export function setUser(userInfo) {
  return Cookies.set('User', JSON.parse(userInfo))
}
export function removeUser() {
  return Cookies.remove('User')
}

export function setBaseUrl(url) {
  return Cookies.set('baseUrl', url)
}
export function getBaseUrl() {
  return Cookies.get('baseUrl')
}



// WEBPACK FOOTER //
// ./src/utils/auth.js